<div class="header">
    <h1>
        <div [innerHTML]="privacyPolicyTitle" async | pipeSafeHTML></div>
    </h1>
    <div [innerHTML]="privacyPolicyText" async | pipeSafeHTML></div>
    <div class="mt-4 w-100 d-flex justify-content-center">
        <div>
            <button class="mwp-button" (click)="download()">Download Privacy Policy Here</button>
        </div>
    </div>
</div>